import { createCRUDService, fetchDropdowns } from './createCRUDService';
import { api } from './api';
import { MEDICAL_STAFF, DROPDOWNS, UPLOAD } from './api/endpoints';

// Create base CRUD service
const baseCRUD = createCRUDService(MEDICAL_STAFF.BASE);

// Export service with additional custom methods
export const MedicalStaffService = {
  ...baseCRUD,

  // Get dropdown data
  getDropdowns: () => fetchDropdowns(DROPDOWNS.BASE),

  // Upload profile photo
  uploadProfilePhoto: async (file) => {
    const formData = new FormData();
    formData.append('image', file);
    const response = await api.upload(UPLOAD.BASE, formData);
    return response.data;
  },
};

export default MedicalStaffService;
